import { render, staticRenderFns } from "./AboutNews.vue?vue&type=template&id=1db18361&scoped=true"
import script from "./AboutNews.vue?vue&type=script&lang=js"
export * from "./AboutNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db18361",
  null
  
)

export default component.exports